/**
 * Co-Producer / Touring Partner / Project Partner form
 */
import Vue from 'vue';
import $ from 'jquery';
import _ from 'lodash';
import VeeValidate,  { Validator } from 'vee-validate';
import vueSelect from 'vue-select';
import refreshToken from '../mixins/refresh-token';

const dictionary = { en: { messages: { required: 'This field is mandatory' } } };

VeeValidate.Validator.localize(dictionary);

Vue.use(VeeValidate);

Validator.extend('media', {
    getMessage: field => 'The ' + field + ' must be a valid media file.',
    validate: value => value[0] ? /^(.+)\.(mp3|MP3|avi|AVI|mp4|MP4|PDF|pdf|PNG|png|JPG|jpg)$/.test(value[0].name) : true
});

Validator.extend('pdf', {
    getMessage: field => 'The ' + field + ' must be a pdf file.',
    validate: value => value[0] ? /^(.+)\.(p|P)(d|D)(f|F)$/.test(value[0].name) : true
});

Validator.extend('mp3', {
    getMessage: field => 'The ' + field + ' must be a mp3 file.',
    validate: value => value[0] ? /^(.+)\.(m|M)(p|P)(3)$/.test(value[0].name) : true
});

Validator.extend('youtube', {
    getMessage: field => 'The ' + field + ' must be a valid youtube url.',
    validate: value => value ? /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/.test(value) : true
});

Validator.extend('positive', {
    getMessage: field => 'The ' + field + ' must be a positive number.',
    validate: value => value ? /^\+?(0|[1-9]\d*)$/.test(value) : true
});

Validator.extend('url', {
    getMessage: field => 'The ' + field + '\'s address must be in the form http://www.website.com.',
    validate: (value) => value ? /^(ftp|http|https):\/\/[^ "]+$/.test(value) : true
});

Validator.extend('date_exists', {
    getMessage: field => 'The ' + field + ' field must be a valid date.',
    validate: (value) => {
        return true;
    }
});

const formProjectComponentConfig = {
    /**
     * Component name
     * @type {String}
     */
    name: 'form-project',

    props: [
        'countries',
        'projectProps',
        'areasImpact',
        'token',
        'previous',
        'action',
        'id',
        'categorie',
        'next',
        'readOnly',
        'errorBags',
        'months',
        'years'
    ],

    components: { 'vueSelect': vueSelect },

    mixins: [ refreshToken ],

    /**
     * Component data
     * @return {Object}
     */
    data () {
        const dataObject = {
            project: {
                copyright: false,
                projectDescription: false,
                planned_date_opening_night: [].push({ country: 75 })
            },
            days: [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31
            ],
            tokenVal: null,
            errorAreaImpact: '',
            scoresError: false
        };

        return dataObject;
    },

    methods: {
        addItem () {
            if (!this.readOnly) {
                this.project.planned_date_opening_night.push({ country: 75 });
            }
        },
        removeItem (index) {
            if (!this.readOnly) {
                this.project.planned_date_opening_night.splice(index, 1);
            }
        },
        validateDate () {
            let canSubmit = true;

            for (let i = 0; i < this.project.planned_date_opening_night.length; i++) {
                let fieldDay = this.$validator.fields.find({
                    name: 'planned_date_opening_night[' + i + '][day]',
                    scope: this.$options.scope
                });

                if (!fieldDay) continue;
                let day = parseInt(this.project.planned_date_opening_night[i].day);
                let isInt = /^-?[0-9]+$/;

                if (!isInt.test(this.project.planned_date_opening_night[i].day)) {
                    canSubmit = false;
                    this.$validator.errors.add({
                        id: fieldDay.name,
                        field: fieldDay.name,
                        msg: 'Invalid date',
                        scope: this.$options.scope
                    });

                    fieldDay.setFlags({
                        invalid: true,
                        valid: false,
                        validated: true
                    });
                }

                if (day > 0) {
                    let fieldMonth = this.$validator.fields.find({
                        name: 'planned_date_opening_night[' + i + '][month]',
                        scope: this.$options.scope
                    });
                    let fieldYear = this.$validator.fields.find({
                        name: 'planned_date_opening_night[' + i + '][year]',
                        scope: this.$options.scope
                    });

                    let date = new Date(parseInt(fieldYear.value), parseInt(fieldMonth.value) - 1, parseInt(fieldDay.value));

                    if (date.getMonth() + 1 === parseInt(fieldMonth.value)) {
                        continue;
                    } else {
                        canSubmit = false;

                        if (!this.errors.has(fieldDay.name)) {
                            this.$validator.errors.add({
                                id: fieldDay.name,
                                field: fieldDay.name,
                                msg: 'Invalid date',
                                scope: this.$options.scope
                            });

                            fieldDay.setFlags({
                                invalid: true,
                                valid: false,
                                validated: true
                            });
                        }
                    }
                } else {
                    this.errors.removeById(fieldDay.name);
                }
            }

            return canSubmit;
        },
        validateForm (e) {
            e.preventDefault();

            if (this.categorie === 'opera') {
                if (this.project.musical_scores.length > 0 || $('.form-wrapper.musical_score_upload a.link-download').length > 0) {
                    console.log('Before = ', this.project.musical_scores);
                    this.$validator.validateAll().then((valid) => {
                        if (valid && this.categorie === 'nextstage') {
                            if (!this.areasImpact.sustainability && !this.areasImpact.inclusivity && !this.areasImpact.digital_transformation) {
                                this.errorAreaImpact = 'This field is mandatory';
                                $([document.documentElement, document.body]).animate({
                                    scrollTop: $('#areas_impact_digital_transformation').parent()
                                        .offset().top - 130
                                }, 500);

                                return false;
                            } else {
                                this.errorAreaImpact = '';
                                let btnSpinner = $('.btn--spinner', e.target);

                                btnSpinner.addClass('right-spin');
                                e.target.submit();

                                return true;
                            }
                        }
                        if (valid && this.project.planned_date_opening_night.length > 0) {
                            if (this.validateDate()) {
                                let btnSpinner = $('.btn--spinner', e.target);

                                btnSpinner.addClass('right-spin');
                                e.target.submit();
                            } else {
                                let fieldName = this.errors.items[0].field;

                                $([document.documentElement, document.body]).animate({
                                    scrollTop: $('[name="' + fieldName + '"]').parent()
                                        .offset().top - 130
                                }, 500);
                            }
                        } else if (!valid) {
                            this.errorAreaImpact = '';
                            let fieldName = this.errors.items[0].field;

                            if (this.categorie === 'nextstage' && !this.areasImpact.sustainability && !this.areasImpact.inclusivity && !this.areasImpact.digital_transformation) {
                                this.errorAreaImpact = 'This field is mandatory';
                            }
                            $([document.documentElement, document.body]).animate({
                                scrollTop: $('[name="' + fieldName + '"]').parent()
                                    .offset().top - 130
                            }, 500);
                        } else if (this.project.planned_date_opening_night.length <= 0) {
                            $([document.documentElement, document.body]).animate({
                                scrollTop: $('.planned-date-wrapper')
                                    .offset().top - 130
                            }, 500);
                        }
                    })
                        .catch(() => {
                            return false;
                        });
                } else {
                    e.preventDefault();
                }
            } else {
                this.$validator.validateAll().then((valid) => {
                    if (valid && this.categorie === 'nextstage') {
                        if (!this.areasImpact.sustainability && !this.areasImpact.inclusivity && !this.areasImpact.digital_transformation) {
                            this.errorAreaImpact = 'This field is mandatory';
                            $([document.documentElement, document.body]).animate({
                                scrollTop: $('#areas_impact_digital_transformation').parent()
                                    .offset().top - 130
                            }, 500);

                            return false;
                        } else {
                            this.errorAreaImpact = '';
                            let btnSpinner = $('.btn--spinner', e.target);

                            btnSpinner.addClass('right-spin');
                            e.target.submit();

                            return true;
                        }
                    }
                    if (valid && this.project.planned_date_opening_night.length > 0) {
                        if (this.validateDate()) {
                            let btnSpinner = $('.btn--spinner', e.target);

                            btnSpinner.addClass('right-spin');
                            e.target.submit();
                        } else {
                            let fieldName = this.errors.items[0].field;

                            $([document.documentElement, document.body]).animate({
                                scrollTop: $('[name="' + fieldName + '"]').parent()
                                    .offset().top - 130
                            }, 500);
                        }
                    } else if (!valid) {
                        this.errorAreaImpact = '';
                        let fieldName = this.errors.items[0].field;

                        if (this.categorie === 'nextstage' && !this.areasImpact.sustainability && !this.areasImpact.inclusivity && !this.areasImpact.digital_transformation) {
                            this.errorAreaImpact = 'This field is mandatory';
                        }
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $('[name="' + fieldName + '"]').parent()
                                .offset().top - 130
                        }, 500);
                    } else if (this.project.planned_date_opening_night.length <= 0) {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $('.planned-date-wrapper')
                                .offset().top - 130
                        }, 500);
                    }
                })
                    .catch(() => {
                        return false;
                    });
            }
        },
        readUrl (e) {
            if ($(e.target)[0].files && $(e.target)[0].files[0]) {
                let reader = new FileReader();

                reader.onload = function (event) {
                    $('#' + $(e.target).data('img-id')).attr('src', event.target.result);
                };

                reader.readAsDataURL($(e.target)[0].files[0]);
            }
        },
        removeFile (element) {
            if (!this.readOnly) {
                let name = $(element.target).attr('data-remove');

                $('[name="remove_' + name + '"]').val('remove');
                $('[data-remove="' + name + '"]').remove();
            }
        },
        addMaterial () {
            if (!this.readOnly) {
                this.project.materials.push({
                    type: null,
                    data: null
                });
            }
        },
        removeMaterial (index) {
            if (!this.readOnly) {
                this.project.materials.splice(index, 1);
            }
        },
        removeUpload (element) {
            if (!this.readOnly) {
                let name = $(element.target).attr('data-remove');

                $('[name="materials[' + name + '][remove]"]').val('remove');
                $('[data-remove="' + name + '"]').remove();
            }
        },
        addScore () {
            if (!this.readOnly) {
                this.project.musical_scores.push({
                    type: null,
                    data: null
                });
            }
        },
        removeScore (index) {
            if (!this.readOnly) {
                this.project.musical_scores.splice(index, 1);
            }
        },
        removeUploadScore (element) {
            if (!this.readOnly) {
                let name = $(element.target).attr('data-remove');

                $('[name="musical_scores[' + name + '][remove]"]').val('remove');
                $('[data-remove="' + name + '"]').remove();
            }
        }
    },

    created () {
        this.project = this.projectProps;
        this.tokenVal = this.token;
    },
    mounted () {
        _.each(this.errorBags, (value, fieldname) => {
            if (fieldname === 'areas_impact[digital_transformation]') {
                this.errorAreaImpact = 'This field is mandatory';
                $([document.documentElement, document.body]).animate({
                    scrollTop: $('#areas_impact_digital_transformation').parent()
                        .offset().top - 130
                }, 500);
            } else {
                const field = this.$validator.fields.find({
                    name: fieldname,
                    scope: this.$options.scope
                });

                console.log('Field error = ', fieldname, value, field);
                this.$validator.errors.add({
                    id: field.name,
                    field: field.name,
                    msg: value[0],
                    scope: this.$options.scope
                });

                field.setFlags({
                    invalid: true,
                    valid: false,
                    validated: true
                });
            }
        });

        if (this.errors.items[0] !== undefined) {
            let fieldName = this.errors.items[0].field;

            $([document.documentElement, document.body]).animate({
                scrollTop: $('[name="' + fieldName + '"]').parent()
                    .offset().top - 130
            }, 500);
        }
    },
    updated () {
        // let self = this;

        // $('.project-datepicker').datetimepicker({
        //     timepicker: false,
        //     format: 'd/m/Y',
        //     onSelectDate: function (selectedDate, datePicker) {
        //         let index = datePicker.data('index');

        //         let yyyy = selectedDate.getFullYear().toString();
        //         let mm = (selectedDate.getMonth() + 1).toString();
        //         let dd  = selectedDate.getDate().toString();
        //         let mmChars = mm.split('');
        //         let ddChars = dd.split('');
        //         let date =  (ddChars[1] ? dd : '0' + ddChars[0])  + '/' + (mmChars[1] ? mm : '0' + mmChars[0]) + '/' + yyyy;

        //         self.project.planned_date_opening_night[index].date = date;
        //     }
        // });
    }
};

const formProjectComponent = Vue.extend(formProjectComponentConfig);

export default formProjectComponent;
